module.exports = __webpack_public_path__ + "img/slide-botttom.47ddcf39.png";